<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('cloudList.name')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('cloudList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center"  prop="sort" :label="$t('cloudList.sort')">
				</el-table-column>

				<el-table-column align="center"  prop="id" label="ID">
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('cloudList.name')">
				</el-table-column>
                <el-table-column align="center" prop="name_lang" :label="$t('cloudList.nameLang')">
				</el-table-column>
                <el-table-column align="center" prop="login_url" :label="$t('cloudList.loginUrl')">
                    <template slot-scope="scope">
									<div v-if="scope.row.login_url.length > 20">
										{{ scope.row.login_url.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.login_url)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										{{ scope.row.login_url }}
									</div>
								</template>
				</el-table-column>
				<el-table-column align="center" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" width="160" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('cloudList.edit') : $t('cloudList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cloudList.sort')" prop="sort">
					<el-input v-model="form.sort"  clearable size="small" :placeholder="$t('cloudList.sort')"  style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cloudList.name')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('cloudList.name')"  style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item :label="$t('cloudList.nameLang')" prop="name_lang">
					<el-input v-model="form.name_lang"  :placeholder="$t('cloudList.nameLang')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('cloudList.loginUrl')" prop="login_url">
					<el-input v-model="form.login_url" :placeholder="$t('cloudList.nameLang')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

        <el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('cloudList.loginUrl')">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
                dialogTitleVisible: false,
				fullTitle: '',
                
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					time:[],
				},
				auth_val: 'CloudService',

                prop: 'sort',
                sort: 'ascending',

				preUrl: "user/cloudServiceList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delCloudService", //删除單条地址
				addUrl: "user/addCloudService", //添加/修改地址
				editStatusUrl:"user/editStatusCloudService",//修改狀態地址

				tableData: [],
				form: {
                    name: "",
                    login_url: "",
                    name_lang: '',
					sort: 1,
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('cloudList.nameRequired'),
						trigger: 'blur',
					}],
					name_lang: [{
						required: true,
						message: this.$t('cloudList.nameLangRequired'),
						trigger: 'blur',
					}],
					login_url: [{
						required: true,
						message: this.$t('cloudList.loginUrlLangRequired'),
						trigger: 'blur',
					}],
					
				},
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			
		},
		methods: {
             // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('cloudList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			async submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('cloudList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			hide(){
                // 初始化表單
					this.form = {
						name: "",
						name_lang: '',
						login_url: '',
						sort: 1,
					}
					this.editIndex = -1
                    this.createModel = false
            },
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						name_lang: '',
						login_url: '',
						sort: 1,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						name_lang: e.row.name_lang,
						login_url: e.row.login_url,
						sort:  e.row.sort
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: "",
                    login_url: "",
                    name_lang: '',
					sort: 1,
				}
			
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
